import { LogManager } from '../../../common/port/log/log.manager.port';
import { AppMetricsTotalIndividualMapper } from '../../../infrastructure/mappers/team-metrics/app-metrics-total-individual.mapper';
import { GetAppMetricsTotalsIndividualRequestDto } from '../../dtos/team-metrics/get-app-metrics-totals-individual.request.dto';
import { GetAppMetricsTotalsIndividualResponseDto } from '../../dtos/team-metrics/get-app-metrics-totals-individual.response.dto';
import { GetAppMetricsTotalIndividualQuery } from '../../queries/team-metrics/get-app-metrics-totals-individual.query';

export class GetAppMetricsTotalIndividualController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAppMetricsTotalIndividualQuery,
    protected readonly mapper: AppMetricsTotalIndividualMapper
  ) {}

  async get(
    props: GetAppMetricsTotalsIndividualRequestDto
  ): Promise<GetAppMetricsTotalsIndividualResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `AppMetricsTotalIndividualComponentController.get encountered an error ${error}`
      );
    }
  }
}
